import { SvbrgQuoteLineItem } from '@/generated/gql/graphql';

export enum QuoteLineItemGridField {
  POSITION = 'position',
  TITLE = 'title',
  DESCRIPTION = 'description',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  UNIT_ID = 'unitId',
  QUANTITY = 'quantity',
  PRICE_PER_UNIT = 'pricePerUnit',
  EARLY_DELIVERY_AT = 'earlyDeliveryAt',
  LATE_DELIVERY_AT = 'lateDeliveryAt',
  DELETE_ACTION = 'deleteAction',
}

export enum QuoteLineItemGridColumnGroup {
  GENERAL = 'general',
  DELIVERY_DATE = 'deliveryDate',
  CLASSIFICATION = 'classification',
  ACTIONS = 'actions',
}

export type QuoteLineItemGridRow = SvbrgQuoteLineItem;
